module.exports = __webpack_public_path__ + "static/media/Rectangle 113.6a20b80e.png";